import { render, staticRenderFns } from "./FacultyDepartmentConnections.vue?vue&type=template&id=29e116d0&scoped=true"
import script from "./FacultyDepartmentConnections.vue?vue&type=script&lang=js"
export * from "./FacultyDepartmentConnections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e116d0",
  null
  
)

export default component.exports